import { createAction } from "redux-actions";

export const YEAR_CHANGED = "YEAR_CHANGED";
export const yearChanged = createAction(YEAR_CHANGED);

export const COUNTRY_CHANGED = "COUNTRY_CHANGED";
export const countryChanged = createAction(COUNTRY_CHANGED);

export const CITIES_CHANGED = "CITIES_CHANGED";
export const citiesChanged = createAction(CITIES_CHANGED);

export const COUNTRIES_CHANGED = "COUNTRIES_CHANGED";
export const countriesChanged = createAction(COUNTRIES_CHANGED);

export const RESET_CITIES = "RESET_CITIES";
export const resetCities = createAction(RESET_CITIES);

export const RESET_ALL = "RESET_ALL";
export const resetAll = createAction(RESET_ALL);
